import React, { useEffect, useState } from 'react'
import NavigateListCustom from '../../../components/navigation/NavigationListCustom'
import { Box, Tab, Tabs, Typography } from '@mui/material'
import { routeName } from '../../../routes/routeName'
import { useParams } from 'react-router-dom';
import { CourseOfStudyApi } from '../../../api/course-of-study/course-of-study.api';
import CourseOfStudyTable from './course-of-study-table';
import { useTranslation } from 'react-i18next';

export default function CourseOfStudyDetail() {
    const { t } = useTranslation();

    const { id } = useParams();
    const [detail, setDetail] = useState<any>()
    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };
    const getDetail = async () => {
        const res = await CourseOfStudyApi.findById(id);
        const data = res.data;
        if (data.status < 300) {
            setDetail(data.data);
        } else {
            setDetail(null);
        }
    }
    useEffect(() => {
        getDetail()
    }, [])
    return (
        <div className="h-auto">
            {/* breadcrumbs */}
            <NavigateListCustom
                navigateData={[
                    {
                        name: t("COUNRSE_OF_STUDT.MANAGE_SCHEDULE"),
                        key: "1",
                        pathName: routeName.cms.CourseofStudy,
                    },
                    {
                        name: `${t('COUNRSE_OF_STUDT.ACADEMIC_YEAR')} ${detail?.academic_year} ${t('COUNRSE_OF_STUDT.SEMESTER')} ${detail?.semester || ''} ${t('COUNRSE_OF_STUDT.LEVEL')} ${detail?.degree?.degree_name || ''} ${t('COUNRSE_OF_STUDT.FACULTY')} ${detail?.faculty?.faculty_name}`,
                        key: "2",
                        pathName: '',
                    },
                ]}
            />

            {/* header */}
            <section className="my-4">
                <Typography variant="h3">{`${t('COUNRSE_OF_STUDT.ACADEMIC_YEAR')} ${detail?.academic_year} ${t('COUNRSE_OF_STUDT.SEMESTER')} ${detail?.semester || ''} ${t('COUNRSE_OF_STUDT.LEVEL')} ${detail?.degree?.degree_name || ''} ${t('COUNRSE_OF_STUDT.FACULTY')} ${detail?.faculty?.faculty_name}`}</Typography>
            </section>
            <Box sx={{ borderBottom: 3, borderColor: '#E5E7EB' }}>
                <Tabs value={value} onChange={handleChange} sx={{
                    "& .MuiTabs-indicator": {
                        display: "none", // ซ่อนเส้นใต้ indicator
                    },
                    "& .MuiTab-root": {
                        borderRadius: "16px 16px 0 0", // มุมโค้ง
                        backgroundColor: "#E5E7EB", // สีพื้นหลังเริ่มต้น (เทาอ่อน)
                        color: "#6B7280", // สีตัวอักษรเริ่มต้น (เทาเข้ม)
                        padding: "8px 24px",
                        minWidth: "80px",
                        textTransform: "none", // ไม่ใช้ตัวพิมพ์ใหญ่
                        fontSize: '16px',
                        fontWeight: '500',
                        transition: "0.3s",
                        "&.Mui-selected": {
                            backgroundColor: "#FACC15", // สีพื้นหลังแท็บที่เลือก (เหลือง)
                            color: "#fff", // สีตัวอักษรเมื่อถูกเลือก
                        },
                    },
                }}>
                    <Tab label={`${t("COUNRSE_OF_STUDT.YEAR_LEVEL")} 1`} />
                    <Tab label={`${t("COUNRSE_OF_STUDT.YEAR_LEVEL")} 2`} />
                    <Tab label={`${t("COUNRSE_OF_STUDT.YEAR_LEVEL")} 3`} />
                    <Tab label={`${t("COUNRSE_OF_STUDT.YEAR_LEVEL")} 4`} />
                </Tabs>
            </Box>
            {value === 0 && <CourseOfStudyTable term={1} academic_year={detail?.academic_year} status_publish={detail?.status_publish_academic_year_1} detail={detail} course_annual_file={detail?.course_annual_file_1} getDetail={getDetail} />}
            {value === 1 && <CourseOfStudyTable term={2} academic_year={detail?.academic_year} status_publish={detail?.status_publish_academic_year_2} detail={detail} course_annual_file={detail?.course_annual_file_2} getDetail={getDetail} />}
            {value === 2 && <CourseOfStudyTable term={3} academic_year={detail?.academic_year} status_publish={detail?.status_publish_academic_year_3} detail={detail} course_annual_file={detail?.course_annual_file_3} getDetail={getDetail} />}
            {value === 3 && <CourseOfStudyTable term={4} academic_year={detail?.academic_year} status_publish={detail?.status_publish_academic_year_4} detail={detail} course_annual_file={detail?.course_annual_file_4} getDetail={getDetail} />}

        </div>
    )
}
